import React from 'react';
import PropTypes from 'prop-types';
import { Formik, Form, FieldArray } from 'formik';

// import { forOwn } from 'lodash-es';

import Button from '@material-ui/core/Button';
import IconButton from '@material-ui/core/IconButton';
import Tooltip from '@material-ui/core/Tooltip';
import AddIcon from '@material-ui/icons/Add';
import RemoveIcon from '@material-ui/icons/Remove';
import { MuiThemeProvider } from '@material-ui/core/styles';

import { theme } from '../../../Theme/theme';
import MetaField from '../../../Components/MetaField/MetaField';

const EditContacts = ({ id, fields, initialValues, name, tooltips, buttons, updateContacts, setViewMode, locale }) => {
  const getDefaultItem = item => {
    const defaultItem = item;
    if (Array.isArray(fields)) {
      fields.forEach(field => {
        if (typeof field.default !== 'undefined') defaultItem[field.name] = field.default;
      });
    }
    return defaultItem;
  };
  return (
    <>
      <Formik
        initialValues={initialValues}
        onSubmit={values => {
          updateContacts({ id, payload: values.contacts });
          setViewMode();
        }}
        render={({ values, errors, touched }) => (
          <Form className="formik-form">
            <FieldArray
              name={name}
              render={arrayHelpers => (
                <>
                  {values[name] && values[name].length > 0 ? (
                    values[name].map((item, index) => (
                      <div key={`item-${item.id}`} className="formik-group">
                        {fields.map(field => (
                          <MetaField
                            key={`field-${field.name}`}
                            name={`${name}[${index}].${field.name}`}
                            value={values[name][index][field.name] || field.default}
                            label={field.label}
                            type={field.type}
                            options={field.options}
                            errors={errors}
                            touched={touched}
                            autoComplete="off"
                            style={{ flexGrow: field.grow ? field.grow : 1 }}
                            locale={locale}
                          />
                        ))}
                        <div className="actions-group">
                          <MuiThemeProvider theme={theme}>
                            <Tooltip key={`tooltip-remove-${name}`} title={tooltips.remove || 'Remove'} placement="top">
                              <IconButton
                                size="small"
                                key={`icon-remove-${name}`}
                                aria-label={tooltips.remove || 'Remove'}
                                color="secondary"
                                onClick={() => arrayHelpers.remove(index)} // remove a friend from the list
                              >
                                <RemoveIcon fontSize="small" />
                              </IconButton>
                            </Tooltip>
                            <Tooltip key={`tooltip-insert-${name}`} title={tooltips.insert || 'Insert'} placement="top">
                              <IconButton
                                size="small"
                                key={`icon-insert-${name}`}
                                aria-label={tooltips.insert || 'Insert'}
                                color="primary"
                                onClick={() =>
                                  arrayHelpers.insert(index, getDefaultItem({ id: values[name].length + 1 }))
                                } // insert an empty string at a position
                              >
                                <AddIcon fontSize="small" />
                              </IconButton>
                            </Tooltip>
                          </MuiThemeProvider>
                        </div>
                      </div>
                    ))
                  ) : (
                    <MuiThemeProvider theme={theme}>
                      <Button
                        type="button"
                        onClick={() => arrayHelpers.push({ id: 1 })}
                        variant="contained"
                        color="default"
                      >
                        {buttons.add || 'Add a contact'}
                      </Button>
                    </MuiThemeProvider>
                  )}
                  <div className="block-actions">
                    <MuiThemeProvider theme={theme}>
                      <Button type="submit" variant="contained" color="primary">
                        {buttons.submit || 'Submit'}
                      </Button>
                    </MuiThemeProvider>
                  </div>
                </>
              )}
            />
          </Form>
        )}
      />
    </>
  );
};

const option = PropTypes.shape({
  value: PropTypes.string.isRequired,
  text: PropTypes.string.isRequired,
});

const field = PropTypes.shape({
  name: PropTypes.string.isRequired,
  label: PropTypes.string,
  type: PropTypes.oneOf(['string', 'number', 'date', 'selection']),
  options: PropTypes.arrayOf(option),
});

const model = PropTypes.shape({
  firstname: PropTypes.string,
  name: PropTypes.string,
  id: PropTypes.string,
  age: PropTypes.number,
});

const personalInfos = PropTypes.arrayOf(model);

EditContacts.propTypes = {
  id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  fields: PropTypes.arrayOf(field),
  initialValues: PropTypes.shape({ personalInfos }),
  name: PropTypes.string,
  tooltips: PropTypes.objectOf(PropTypes.string),
  buttons: PropTypes.objectOf(PropTypes.string),
  updateContacts: PropTypes.func.isRequired,
  setViewMode: PropTypes.func.isRequired,
  locale: PropTypes.string,
};

EditContacts.defaultProps = {
  fields: [
    { name: 'one_line_street', type: 'string', label: 'Voie' },
    { name: 'zip', type: 'string', label: 'Code Postal' },
    { name: 'city', type: 'string', label: 'Ville' },
  ],
  initialValues: {
    personalInfos: [
      { one_line_street: 'jason', zip: 'tuche', city: '20', id: '1' },
      { one_line_street: 'talor', zip: 'jared', city: '20', id: '2' },
      { one_line_street: 'boris', zip: 'ian', city: '20', id: '3' },
      { one_line_street: 'ian', zip: 'brent', city: '20', id: '4' },
    ],
  },
  name: 'contacts',
  tooltips: {},
  buttons: {},
  locale: 'fr',
};

export default EditContacts;
